import { useQuery } from "@tanstack/react-query";

import { readDexSdk } from "../dex-sdk";

export interface GetTokenBalanceArgs {
  accountAddr: string;
  tokenAddr: string;
  tokenDecimals: number;
}

export function tokenBalanceQueryKey({
  accountAddr,
  tokenAddr,
  tokenDecimals,
}: GetTokenBalanceArgs) {
  return ["tokenBalance", accountAddr, tokenAddr, tokenDecimals] as const;
}

export function useTokenBalance({ accountAddr, tokenAddr, tokenDecimals }: GetTokenBalanceArgs) {
  return useQuery({
    queryKey: tokenBalanceQueryKey({ accountAddr, tokenAddr, tokenDecimals }),
    queryFn: () => getTokenBalance({ accountAddr, tokenAddr, tokenDecimals }),
    enabled: !!accountAddr && !!tokenAddr && !!tokenDecimals,
  });
}

export const getTokenBalance = async ({
  accountAddr,
  tokenAddr,
  tokenDecimals,
}: GetTokenBalanceArgs) => {
  return await readDexSdk.tokenBalance(accountAddr, tokenAddr, tokenDecimals);
};
